import * as React from "react";
import { PureComponent, ReactNode } from "react";
import { connect } from "react-redux";
import { fetchOrgs, setCurrentOrg } from "../actions";

import { RootDispatch, RootState } from "../../types";
import { Organization } from "../../organizations/types";
import NoValidOrgComponent from "../components/NoValidOrgComponent";
import { User } from "../../session/types";
import LoadingFullScreen from "../../../components/LoadingFullScreen";
import MultiOrgSelectContainer from "./MultiOrgSelectContainer";

interface StateProps {
  currentUser: User | null;
  orgs: Organization[] | null;
  loading: boolean;
  currentOrg: Organization | null;
}

interface DispatchProps {
  fetchOrgs: () => void;
  setOrg: (org: Organization) => void;
}

type Props = StateProps & DispatchProps & { children: ReactNode };

class OrganizationProvider extends PureComponent<Props> {
  public componentDidMount() {
    this.props.fetchOrgs();
  }

  public componentDidUpdate(): void {
    if (this.props.orgs?.length === 1 && !this.props.currentOrg) {
      this.props.setOrg(this.props.orgs[0]);
    }
  }

  public render() {
    const { currentUser, orgs, loading, currentOrg } = this.props;

    if (loading) {
      return <LoadingFullScreen />;
    }

    if (!orgs) {
      return null;
    }

    if (orgs && orgs.length === 0) {
      return <NoValidOrgComponent user={currentUser} />;
    } else if (orgs && orgs.length > 1 && !currentOrg) {
      return <MultiOrgSelectContainer />;
    } else if (orgs.length === 1 && !currentOrg) {
      return null;
    } else {
      return React.Children.toArray(this.props.children);
    }
  }
}

export default connect(
  (state: RootState): StateProps => ({
    currentUser: state.session.data.currentUser,
    orgs: state.orgs.data,
    loading: state.orgs.loading,
    currentOrg: state.orgs.currentOrganization
  }),
  (dispatch: RootDispatch): DispatchProps => ({
    fetchOrgs: () => dispatch(fetchOrgs()),
    setOrg: org => dispatch(setCurrentOrg(org))
  })
)(OrganizationProvider);
